import { c as _c } from "react/compiler-runtime";
import { useAuth } from '@morfi/backend-sdk-v2/client';
import type { OnrampClient } from '@morfi/onramp-sdk';
import { useOnrampRealtime } from '@morfi/onramp-sdk/react';
import type { OnrampRealtime, OnrampRealtimeOptions } from '@morfi/onramp-sdk/realtime';
import { useNetworkConfig } from '@/lib/network/use-network-config';
import { logger } from '@/lib/telemetry/logger';
export function useFundingRealtime(client, t0) {
  const $ = _c(5);
  const active = t0 === undefined ? true : t0;
  const {
    user,
    isAuthenticated
  } = useAuth();
  const {
    natsUrl,
    network
  } = useNetworkConfig();
  const t1 = isAuthenticated && user ? `morfi.onramp.private.${user.id}.v0` : undefined;
  const t2 = network === "local" ? "devnet" : network;
  let t3;
  if ($[0] !== active || $[1] !== natsUrl || $[2] !== t1 || $[3] !== t2) {
    t3 = {
      server: natsUrl,
      subject: t1,
      network: t2,
      active,
      onEvent: _temp,
      onError: _temp2
    };
    $[0] = active;
    $[1] = natsUrl;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return useOnrampRealtime(client, t3);
}
function _temp2(code) {
  return logger.warn("onramp.realtime_failed", {
    code
  });
}
function _temp(event) {
  if (process.env.NODE_ENV !== "production") {
    logger.info("onramp.realtime_event", event);
  }
}